import { FC } from 'react'
import { List, ListItem } from '@mui/material'

import { BottomSection } from '@/components/layouts/CurbsNav/types'
import CurbsNavCollapsibleSection from '@/components/layouts/CurbsNavCollapsibleSection'

interface CurbsNavDrawerSwitchSectionProps {
  drawerOpen: boolean
  onExpandDrawer: () => void
  section: BottomSection
}

const CurbsNavDrawerSwitchSection: FC<CurbsNavDrawerSwitchSectionProps> = ({
  drawerOpen,
  onExpandDrawer,
  section,
}) => {
  return (
    // The section renders as a list item, so it needs a list of its own here.
    <List>
      <CurbsNavCollapsibleSection
        drawerOpen={drawerOpen}
        onExpandDrawer={onExpandDrawer}
        icon={section.icon}
        title={section.title}
        testId={section.testId}
      >
        {section.items.map(item => (
          <ListItem key={item.title} disablePadding sx={{ display: 'block' }}>
            {item.component}
          </ListItem>
        ))}
      </CurbsNavCollapsibleSection>
    </List>
  )
}

export default CurbsNavDrawerSwitchSection
